import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import bestBudgetIcon from "../Assets/bestBudgetIcon.webp";
import twitterXIcon from "../Assets/LandingWebsite/twiiterXIcon.png";
import youtubeIcon from "../Assets/LandingWebsite/youtubeIcon.png";
import facebookIcon from "../Assets/LandingWebsite/facebookIcon.png";
import instagramIcon from "../Assets/LandingWebsite/instagramIcon.png";
import copyRightIcon from "../Assets/LandingWebsite/copyRightIcon.svg";
import linkedInIcon from "../Assets/LandingWebsite/linkedInIcon.png";
import { MenuContext } from '../MenuContext';
import "./Footer.css";

const Footer = () => {
  const { isMenuOpen, toggleMenu } = useContext(MenuContext);

  const navigate = useNavigate();

  const handleSocialClick = (url) => {
    window.open(url, '_blank');
  };
  const handleCloseOpenNavbar = () => {
    if (isMenuOpen === true) {
      toggleMenu(false)
    } else
      return
  }

  return (
    <div className="website-footer-section">
      <div className="section section-container6">
        <div className="footer-routes-box">
          <div className="application-div">
            <div className="application-title"> <h4 style={{lineHeight:'1rem',marginBottom:'0.5rem'}}>Application</h4></div>
            <p
              onClick={() => {
      
                navigate("/");
                handleCloseOpenNavbar();
              }}
            >
              Home
            </p>
            <p
              onClick={() => {
         
                navigate("/why-best-budget");
                handleCloseOpenNavbar();
              }}
            >
              Why Best Budget
            </p>
            <p
              onClick={() => {
          
                navigate("/pricing");
                handleCloseOpenNavbar();
              }}
            >
              Pricing
            </p>
            <p
              onClick={() => {
            
                navigate("/learn");
                handleCloseOpenNavbar();
              }}
            >
              Learn
            </p>
          </div>
          <div className="legal-div">
            <div className="legal-title"><h4 style={{lineHeight:'1rem',marginBottom:'0.5rem'}}>Legal</h4></div>
            <p
              onClick={() => {
         
                navigate("/privacy-policy");
                handleCloseOpenNavbar();
              }}
            >
              Privacy Policy
            </p>
            <p
              onClick={() => {
          
                navigate("/service-terms");
                handleCloseOpenNavbar();
              }}
            >
              Service Terms
            </p>
            <p
              onClick={() => {
           
                navigate("/security");
                handleCloseOpenNavbar();
              }}
            >
              Security
            </p>
            <p
              onClick={() => {
      
                navigate("/cookies-policy");
                handleCloseOpenNavbar();
              }}
            >
              Cookies Policy
            </p>
          </div>
          <div className="about-div">
            <div className="about-title"> <h4 style={{lineHeight:'1rem',marginBottom:'0.5rem'}}>About</h4></div>
            <p
              onClick={() => {
         
                navigate("/about-us");
                handleCloseOpenNavbar();
              }}
            >
              About Us
            </p>
            <p
              onClick={() => {
            
                navigate("/blog");
                handleCloseOpenNavbar();
              }}
            >
              Blog
            </p>
            <p onClick={() => {
           
              navigate("/about-us");
              handleCloseOpenNavbar();
            }}>Support</p>
          </div>
        </div>
        <div className="footer-title-box">

          
          <div className="follow-us-on">
            <small className="caption" >Follow us on</small>
          </div>
          <div className="social-media-icon-tray">
            <img loading="lazy" alt="our twiiter handle" src={twitterXIcon} className="twitter-icon" onClick={() => { handleSocialClick("https://twitter.com/BestBudget_") }} />
            <img loading="lazy" alt="our insta page" src={instagramIcon} className="instagram-icon" onClick={() => { handleSocialClick("https://www.instagram.com/bestbudgetapp") }} />
            <img loading="lazy" alt="our facebook page" src={facebookIcon} className="facebook-icon" onClick={() => { handleSocialClick("https://www.facebook.com/profile.php?id=61576600230600") }} />
            <img loading="lazy" alt="our youtube channel for learning" src={youtubeIcon} className="youtube-icon" onClick={() => { handleSocialClick("https://www.youtube.com/channel/UClxaV2Vn09kLB9aU6yxh5HA") }} />
            <img loading="lazy" alt="our linkedin page" src={linkedInIcon} className="linkedin-icon" onClick={() => { handleSocialClick("https://www.linkedin.com/showcase/100918723/admin/feed/posts/") }} />
          </div>
          <div className="copy-right-panel">
            <small className="caption">
              Copyright
              <img alt="" src={copyRightIcon} />
              2025 CREXIN Technologies.
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
